
/**
 * MG Page Tabbed Carousel Navigation
 * Only affects the Holiday page carousel.
 */

(() => {
  function initializeCarousel(carousel) {
    const panels = carousel.querySelectorAll(
      '.mg-plp-tabbed-grid__panel'
    );

    panels.forEach((panel) => {
      const grid = panel.querySelector('.product-grid');

      if (!grid || grid.dataset.carouselReady === 'true') return;

      grid.dataset.carouselReady = 'true';

      const controls = document.createElement('div');
      controls.className = 'mg-page-carousel__controls';

      const previous = document.createElement('button');
      previous.type = 'button';
      previous.className = 'mg-page-carousel__arrow';
      previous.setAttribute('aria-label', 'Previous products');
      previous.textContent = '←';

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'mg-page-carousel__arrow';
      next.setAttribute('aria-label', 'Next products');
      next.textContent = '→';

      controls.append(previous, next);
      grid.insertAdjacentElement('afterend', controls);

      function updateButtons() {
        const maxScroll = grid.scrollWidth - grid.clientWidth;

        controls.hidden = maxScroll <= 2;
        previous.disabled = grid.scrollLeft <= 2;
        next.disabled = grid.scrollLeft >= maxScroll - 2;
      }

      function scrollProducts(direction) {
        const card = grid.querySelector('.product-grid__item');
        if (!card) return;

        const cardWidth = card.getBoundingClientRect().width;
        const styles = window.getComputedStyle(grid);
        const gap = parseFloat(styles.columnGap) || 0;

        const visibleCount = Math.max(
          1,
          Math.round(grid.clientWidth / (cardWidth + gap))
        );

        grid.scrollBy({
          left: direction * visibleCount * (cardWidth + gap),
          behavior: 'smooth'
        });
      }

      previous.addEventListener('click', () => scrollProducts(-1));
      next.addEventListener('click', () => scrollProducts(1));

      grid.addEventListener('scroll', updateButtons, {
        passive: true
      });

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(updateButtons);
        observer.observe(grid);
      }

      updateButtons();
    });
  }

  function initializeAll() {
    document
      .querySelectorAll('.mg-page-tabbed-carousel')
      .forEach(initializeCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
